import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function Loading({ additionalData }: componentTypes.LoadingProps) {
  const { hitsPerPage } = additionalData;

  return (
    <>
      {[...Array(hitsPerPage).keys()].map((i) => (
        <div className="col-12 col-md-6 col-lg-4" key={i}>
          <div className="card-downloads vertical">
            <div className="card-downloads-img ratio ratio-1x1" />
            <div className="card-downloads-top">
              <h2 className="placeholder-glow">
                <span className="placeholder col-12" />
              </h2>
              <p className="placeholder-glow">
                <span className="placeholder col-12" />
                <span className="placeholder col-12" />
              </p>
            </div>
            <div className="card-downloads-foot">
              <p className="placeholder-glow">
                <span className="placeholder col-4" />
              </p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
